import { Map } from 'immutable'
import { createSelector } from 'reselect'
import { root as endUserRoot } from '../selectors'
import { Property } from './models'
import { receiveAttributes } from './actions'
import ClearbitBlacklist from 'constants/ClearbitBlacklist'

export const root = createSelector(endUserRoot, (endUserRoot) => endUserRoot.get('attributes'))

export const attributesFetched = (state) => root(state).get('status') === receiveAttributes.toString()

export const properties = createSelector(root, (root) => {
  return root.get('properties')
})
export const events = createSelector(root, (root) => root.get('events'))

export const propertiesOptions = createSelector(properties, (properties) => {
  return properties.map(({ name, type, displayName }) => Map({ label: displayName || name, value: name, type: type }))
})

export const filteredProperties = createSelector(propertiesOptions, (properties) => {
  const blacklist = ClearbitBlacklist
  const filteredProperties = properties.filter((property) => !blacklist.includes(property.get('label')))
  return filteredProperties.toJS()
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/attribute/selectors.js